import { Link } from 'react-router-dom';
import clock from '../../../assets/icons/time.png';
import userIcon from '../../../assets/icons/user (1).png'; 
import '../../../assets/styles/main-styles.css';

const NewsCard = ({ img, title, text, name, date, className, height, id, url }) => {
    return (
        <Link
            to={url || "#"} 
            className={`group flex flex-col h-full rounded-2xl text-[14px] bg-white
                overflow-hidden border border-gray-100 shadow-sm transition-all duration-300 
                hover:shadow-md hover:-translate-y-1 ${className || ''}`}
        >
            {/* تصویر - اضافه کردن افکت زوم ملایم در هاور */}
            <div className="relative overflow-hidden shrink-0 h-[150px]">
                <img
                    src={img}
                    alt={title}
                    className={`w-full object-cover transition-transform h-[150px]
                         duration-500 group-hover:scale-105 ${height || 'h-[160px]'}`}
                />
            </div>

            {/* محتوا */}
            <div className='p-4 flex flex-col flex-grow gap-2.5'>
                {/* تغییر رنگ تایتل به رنگ بنفش اختصاصی در حالت هاور */}
                <h6 className="font-bold text-gray-800 line-clamp-2 text-md transition-colors group-hover:text-purple">
                    {title}
                </h6>
                
                {text && (
                    <p className="text-justify text-gray-500 text-[13px] hidden lg:line-clamp-2 leading-relaxed">
                        {text}
                    </p>
                )}

                {/* فوتر کارت - با mt-auto همیشه در انتهای کارت قرار می‌گیرد */}
                <div className="flex w-full justify-between items-center text-[#858585]
                text-[11px] mt-auto pt-3 border-t border-gray-100">
                    <span className="flex items-center gap-1">
                        <img
                            src={userIcon}
                            alt="author"
                            className='w-[12px] h-[12px] object-contain opacity-60'
                        />
                        <span>{name}</span>
                    </span>
                    
                    <span className="flex items-center gap-1">
                        <img
                            src={clock}
                            alt="date"
                            className='w-[12px] h-[12px] object-contain opacity-60'
                        />
                        <span>{date}</span>
                    </span>
                </div>
            </div>
        </Link>
    );
};

export default NewsCard;
